import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { AppState, RootState, Dispatcher } from 'AppTypes'

import AppLogo from './AppLogo'
import MainMenu from './MainMenu'
import LogoList from './LogoList'

import './LeftSidebar.css'

type Props = {
  appState: AppState
  dispatch: Dispatcher
}

const LeftSidebar: React.FC<Props> = ({
  appState: {
    isMainAppSidebarOpen
  }
}) => {
  const className = classNames({ active: isMainAppSidebarOpen })

  return (
    <nav id="sidebar" className={className}>
      <AppLogo />
      <MainMenu />
      <LogoList />
    </nav>
  )
}

export default connect((state: RootState) => ({
  appState: state.app
}))(LeftSidebar)
